import KendoDataSourceBase from '../KendoDataSourceBase'

import Schema from './Schema'

export default {
    mixins: [
        KendoDataSourceBase, 
        Schema
    ],
    mounted() {
        this.kendoDataSource = new kendo.data.SchedulerDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.SchedulerDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoSchedulerDataSource/KendoSchedulerDataSourceMixin.js